import { useState, useMemo } from "react"
import { Calendar, Clock, Plus, X, ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "../../ui/button"
import { Checkbox } from "../../ui/checkbox"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select"
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card"
import { Calendar as CalendarComponent } from "../../ui/calendar"
import { Badge } from "../../ui/badge"
import { Row, Col, Input } from '../../ui/ot'
const HolidayAndClosureManagement = ({

}) => {


    return (<Row>
        <Col span={24}>
        
        </Col>
    </Row>)
}
export default HolidayAndClosureManagement